import { sortAlphabetically } from '../lib/sorting';

import APIClient from './APIClient';

const {
  REACT_APP_ONBOARDING_API_HOST: ONBOARDING_API_HOST,
  REACT_APP_CAMPUSES_ENDPOINT: CAMPUSES_ENDPOINT,
} = process.env;

export const urlFor = schoolId =>
  `${ONBOARDING_API_HOST}${CAMPUSES_ENDPOINT}`.replace('{schoolId}', schoolId);

const isCampusEnabled = campus => !(campus?.disabled ?? false);

export default class CampusesAPI {
  static getCampusesFor = (schoolId, token) =>
    APIClient.get(urlFor(schoolId), token).then(response => {
      const campuses = response.data
        .filter(isCampusEnabled)
        .map(({ name, id, country, state, blockedReasons }) => ({
          value: id,
          label: name,
          country,
          state,
          blockedReasons: blockedReasons || [],
        }));

      return sortAlphabetically(campuses, 'label');
    });
}
